import React, { useState, useEffect } from 'react';
import {
    Box,
    Container,
    Typography,
    Paper,
    Alert,
    Divider
} from '@mui/material';
import { IDispatcher, useProxyWatch } from '@fanfanlo';
import { user } from '@app/model';
import { autoWebViewJs } from '@droid/android';

import FallDetectionWrapper from './FallDetectionWrapper';
import ShakeDetectionWrapper from './ShakeDetectionWrapper';
import { SENSOR_MONITORING_STATE_CHANGED } from './constants';

function EmergencyCallSettings({dispatcher}:{dispatcher:IDispatcher}){
    // UI展开状态管理
    const [fallExpanded, setFallExpanded] = useState(false);
    const [shakeExpanded, setShakeExpanded] = useState(false);
    
    // 状态管理现在由各自的Wrapper组件内部处理，这里只需要UI展开状态

    // 监听用户登录状态
    const [userToken] = useProxyWatch(user, 'data.storeData.user_token', user.data.storeData.user_token);
    const isLoggedIn = !!userToken;

    // 确保同一时间只有一个功能展开
    const handleToggleExpanded = (
        type: 'fall' | 'shake', 
        expanded: boolean
    ) => {
        if (expanded) {
            // 如果要展开，先收起其他的
            setFallExpanded(type === 'fall');
            setShakeExpanded(type === 'shake');
        } else {
            // 如果要收起，只收起当前的
            switch (type) {
                case 'fall':
                    setFallExpanded(false);
                    break;
                case 'shake':
                    setShakeExpanded(false);
                    break;
            }
        }
    };

    // 状态管理和事件监听现在由各自的Wrapper组件内部处理

    return (
        <Box maxWidth="md" sx={{ py: 3 }}>

            {/* 功能模块 */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* 摔倒检测 */}
                <FallDetectionWrapper
                    title="📱 摔倒呼救"
                    isExpanded={fallExpanded}
                    onToggleExpanded={(expanded) => handleToggleExpanded('fall', expanded)}
                    animationType="fall"
                    dispatcher={dispatcher}
                />

                {/* 摇一摇检测 */}
                {/* <ShakeDetectionWrapper
                    title="🤳 摇一摇呼救"
                    isExpanded={shakeExpanded}
                    onToggleExpanded={(expanded) => handleToggleExpanded('shake', expanded)}
                    animationType="shake"
                /> */}
            </Box>

        </Box>
    );
};

export default EmergencyCallSettings;